import { apiGateway } from "@/shared/apiGateway";

const getClientListing = context => {
  return apiGateway
    .apiGatewayGET("api/data-management/clients")
    .then(data => {
      return context.commit("set_client_listing", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Clients"], {
        root: true
      });
    });
};

const getClient = (context, clientId) => {
  return apiGateway
    .apiGatewayGET("api/data-management/clients/" + clientId)
    .then(data => {
      context.commit("set_client_contacts_listing", data.contacts);
      delete data.clientContacts;
      context.commit("set_site_listing", data.sites);
      delete data.sites;
      context.commit("set_client", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Client"], {
        root: true
      });
    });
};

const addClient = (commit, client) => {
  return apiGateway
    .apiGatewayPOST("api/data-management/clients", client)
    .then(data => {
      return data;
    });
};

const editClient = (commit, client) => {
  return apiGateway
    .apiGatewayPUT("api/data-management/clients/", client)
    .then(() => {
      return;
    });
};

const archiveClient = (context, archiveClient) => {
  return apiGateway
    .apiGatewayPATCH("api/data-management/clients/archive", archiveClient)
    .then(() => {
      return;
    });
};

const deleteClient = (context, clientId) => {
  return apiGateway
    .apiGatewayDELETE("api/data-management/clients/" + clientId)
    .then(() => {
      return;
    });
};

const reactivateClient = (context, clientId) => {
  return apiGateway
    .apiGatewayPATCH("api/data-management/clients/reactivate/" + clientId)
    .then(() => {
      return;
    });
};

const getSiteListing = (context, clientId) => {
  return apiGateway
    .apiGatewayGET("api/data-management/sites?clientId=" + clientId)
    .then(data => {
      return context.commit("set_site_listing", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Sites"], {
        root: true
      });
    });
};

const getSite = (context, siteId) => {
  return apiGateway
    .apiGatewayGET("api/data-management/sites/" + siteId)
    .then(data => {
      context.commit("set_building_listing", data.buildings);
      delete data.buildings;
      context.commit("set_site", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Site"], {
        root: true
      });
    });
};

const addSite = (commit, site) => {
  return apiGateway
    .apiGatewayPOST("api/data-management/sites", site)
    .then(data => {
      return data;
    });
};

const editSite = (commit, site) => {
  return apiGateway
    .apiGatewayPUT("api/data-management/sites/", site)
    .then(() => {
      return;
    });
};

const deleteSite = (context, siteId) => {
  return apiGateway
    .apiGatewayDELETE("api/data-management/sites/" + siteId)
    .then(() => {
      return;
    });
};

const archiveSite = (context, archiveSite) => {
  return apiGateway
    .apiGatewayPATCH("api/data-management/sites/archiveSite", archiveSite)
    .then(() => {
      return;
    });
};

const reactivateSite = (context, siteId) => {
  return apiGateway
    .apiGatewayPATCH("api/data-management/sites/reactivate/" + siteId)
    .then(() => {
      return context.commit("set_client_to_active");
    });
};

const getBuildingListing = (context, siteId) => {
  return apiGateway
    .apiGatewayGET("api/data-management/buildings?siteId=" + siteId)
    .then(data => {
      return context.commit("set_building_listing", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Buildings"], {
        root: true
      });
    });
};

const getBuilding = (context, buildingId) => {
  return apiGateway
    .apiGatewayGET("api/data-management/buildings/" + buildingId)
    .then(data => {
      context.commit("set_plant_listing", data.plants);
      delete data.plants;
      context.commit("set_building", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Building"], {
        root: true
      });
    });
};

const addBuilding = (commit, building) => {
  return apiGateway
    .apiGatewayPOST("api/data-management/buildings", building)
    .then(data => {
      return data;
    });
};

const editBuilding = (commit, building) => {
  return apiGateway
    .apiGatewayPUT("api/data-management/buildings/", building)
    .then(() => {
      return;
    });
};

const archiveBuilding = (context, archiveBuilding) => {
  return apiGateway
    .apiGatewayPATCH(
      "api/data-management/buildings/archiveBuilding",
      archiveBuilding
    )
    .then(() => {
      return;
    });
};

const reactivateBuilding = (context, buildingId) => {
  return apiGateway
    .apiGatewayPATCH("api/data-management/buildings/reactivate/" + buildingId)
    .then(() => {
      return context.commit("set_site_to_active");
    });
};

const deleteBuilding = (context, buildingId) => {
  return apiGateway
    .apiGatewayDELETE("api/data-management/buildings/" + buildingId)
    .then(() => {
      return;
    });
};

const getPlantListing = (context, buildingId) => {
  return apiGateway
    .apiGatewayGET("api/data-management/plant?buildingId=" + buildingId)
    .then(data => {
      return context.commit("set_plant_listing", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Plant"], {
        root: true
      });
    });
};

const getPlant = (context, plantId) => {
  return apiGateway
    .apiGatewayGET("api/data-management/plant/" + plantId)
    .then(data => {
      context.commit("set_plant", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Plant item"], {
        root: true
      });
    });
};

const addPlant = (commit, plant) => {
  return apiGateway
    .apiGatewayPOST("api/data-management/plant", plant)
    .then(data => {
      return data;
    });
};

const editPlant = (commit, plant) => {
  return apiGateway
    .apiGatewayPUT("api/data-management/plant/", plant)
    .then(() => {
      return;
    });
};

const archivePlant = (context, archivePlant) => {
  return apiGateway
    .apiGatewayPATCH("api/data-management/plant/archivePlant", archivePlant)
    .then(() => {
      return;
    });
};

const deletePlant = (context, plantId) => {
  return apiGateway
    .apiGatewayDELETE("api/data-management/plant/" + plantId)
    .then(() => {
      return;
    });
};

const reactivatePlant = (context, plantId) => {
  return apiGateway
    .apiGatewayPATCH("api/data-management/plant/reactivate/" + plantId)
    .then(() => {
      return context.commit("set_building_to_active");
    });
};

const getPlantTypes = context => {
  return apiGateway
    .apiGatewayGET("api/data-management/planttypes")
    .then(data => {
      return context.commit("set_plantTypes", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting plant types"], {
        root: true
      });
    });
};

const getConsultantListing = context => {
  return apiGateway
    .apiGatewayGET("api/data-management/consultants")
    .then(data => {
      return context.commit("set_consultant_listing", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Consultants"], {
        root: true
      });
    });
};

const getConsultant = (context, consultantId) => {
  return apiGateway
    .apiGatewayGET("api/data-management/consultants/" + consultantId)
    .then(data => {
      context.commit("set_consultant", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Consultant item"], {
        root: true
      });
    });
};

const addConsultant = (commit, consultant) => {
  return apiGateway
    .apiGatewayPOST("api/data-management/consultants", consultant)
    .then(data => {
      return data;
    });
};

const editConsultant = (commit, consultant) => {
  return apiGateway
    .apiGatewayPUT("api/data-management/consultants/", consultant)
    .then(() => {
      return;
    });
};

const getClientContact = (context, clientContactId) => {
  return apiGateway
    .apiGatewayGET("api/data-management/clientContacts/" + clientContactId)
    .then(data => {
      context.commit("set_client_contact", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch(
        "SHOW_ERROR_ALERT",
        ["Error getting Client Contact item"],
        {
          root: true
        }
      );
    });
};

const editClientContact = (commit, clientContact) => {
  return apiGateway
    .apiGatewayPUT("api/data-management/clientContacts/", clientContact)
    .then(() => {
      return;
    });
};

const addClientContact = (commit, clientContact) => {
  return apiGateway
    .apiGatewayPOST("api/data-management/clientContacts", clientContact)
    .then(data => {
      return data;
    });
};

const deleteClientContact = (context, id) => {
  return apiGateway
    .apiGatewayDELETE("api/data-management/clientContacts/" + id)
    .then(() => {
      context.commit("delete_client_contact_by_id", id);
      return;
    });
};

export default {
  addBuilding,
  addConsultant,
  addClient,
  addClientContact,
  addPlant,
  addSite,
  archiveBuilding,
  archiveClient,
  archivePlant,
  archiveSite,
  deleteBuilding,
  deleteClient,
  deleteClientContact,
  deleteSite,
  deletePlant,
  editBuilding,
  editClient,
  editClientContact,
  editConsultant,
  editPlant,
  editSite,
  getBuilding,
  getBuildingListing,
  getClient,
  getClientListing,
  getClientContact,
  getConsultant,
  getConsultantListing,
  getPlant,
  getPlantListing,
  getPlantTypes,
  getSiteListing,
  getSite,
  reactivateBuilding,
  reactivateClient,
  reactivatePlant,
  reactivateSite
};
